module.exports = __webpack_public_path__ + "img/SKMJ_crain3.28da5970.jpg";